<template>
  <div class="md-layout">
    <!-- <div class="md-layout-item md-size-35"></div> -->
    <div
      class="md-layout-item md-size-25"
      style="
        display: block;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
      "
    >
      <form v-if="!pass" @submit.prevent="checkpass()">
        <md-field>
          <label>Password</label>
          <md-input type="password" v-model="password"> </md-input>
        </md-field>
        <md-button class="md-success" @click="checkpass()">Submit</md-button>
      </form>
      <form v-if="pass" @submit.prevent="onSubmit()">
        <md-field>
          <label>Mobile No</label>
          <md-input type="number" v-model="mobileNo"> </md-input>
        </md-field>
        <md-button class="md-success" @click="onSubmit()">Submit</md-button>
      </form>
      <div v-if="nodata">
        <br /><br /><br />
        <label>No record found.</label>
      </div>
      <div v-if="alldoc.length > 0">
        <br /><br /><br />
        <label>Found multiple document</label>
        <div>
          <md-button
            class="md-success"
            v-for="(item, index) in alldoc"
            :key="index"
            @click="
              selectdoc(index);
              nodata = false;
            "
          >
            {{ "Doc" + (index + 1) }}
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { db, applicationsCollection, departmentsCollection } from "@/firebase";
export default {
  data() {
    return {
      mobileNo: "",
      alldoc: [],
      nodata: false,
      password: "",
      pass: false,
    };
  },
  methods: {
    checkpass() {
      if (this.password == "aavinadmin1@#") {
        this.pass = true;
      }
    },
    onSubmit() {
      console.log("entered", this.mobileNo);
      let self = this;
      db.collection("applications")
        .where("mobile", "==", this.mobileNo)
        .where("razerpay", "!=", null)
        .get()
        .then((querySnapshot) => {
          if (querySnapshot.docs.length > 1) {
            this.alldoc = querySnapshot.docs;
          } else if (querySnapshot.docs.length == 1) {
            let doc = querySnapshot.docs[0];
            self.$router.push({
              name: "preview",
              params: {
                preview: doc,
              },
            });
          } else {
            this.nodata = true;
          }
          // for (let i in querySnapshot.docs) {
          //   let doc = querySnapshot.docs[i];
          //   // alldoc.push(doc.data().applicationId);
          //   console.log(doc.id, " => ", doc.data());
          // }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    selectdoc(index) {
      let doc = this.alldoc[index];
      this.$router.push({
        name: "preview",
        params: {
          preview: doc,
        },
      });
    },
  },
  created: function () {},
};
</script>